import { FC } from 'react';
import { ButtonLink } from '@domgen/base-design-system-2.0/atoms/ButtonLink';
import { Phone } from '../../../assets/icons/Phone';
import { MouseIcon } from '../../../assets/icons/MouseIcon';
import { HybridButtonLabel, HybridFrame } from '../sections/hybrid';
import { LandingVariantProps } from './types';

/**
 * LP2 hybrid (`phone-and-link-v2`, Sept 2026) — the LP1 hybrid layout with an
 * online-registration option: phone block (heading, button, opening hours) and
 * online block (heading, button), side by side on desktop and stacked on mobile,
 * and no repeated button after the benefits. Buttons match V1 LP2 (phone: V1 phone
 * style; online: V1 online style); dials the same number as V1.
 * Mockups: claude-notes/lp-hybrid-lp1 (EN_LP2_hybrid_mockups).
 */
export const PhoneAndLinkV2: FC<LandingVariantProps> = ({ data, copy, onCtaClick }) => {
  const phoneHref = copy.ctaPhoneLink ?? data.ctaPhoneLink;
  return (
    <HybridFrame
      data={data}
      copy={copy}
      hoursAfterBenefits={false}
      cta={
        <div className="hyb-cta-pair">
          <div className="hyb-cta">
            <h2 className="hyb-cta-head">{`${copy.registration}**`}</h2>
            <ButtonLink
              leftIcon={Phone()}
              href={phoneHref}
              variant="secondary"
              id="phone-cta"
              onClick={() => onCtaClick('phone', phoneHref)}
            >
              <HybridButtonLabel text={copy.ctaPhoneText} />
            </ButtonLink>
            <p className="hyb-hours">{copy.phoneSubCopy}</p>
          </div>
          <div className="hyb-cta">
            <h2 className="hyb-cta-head">{copy.onlineCopy}</h2>
            <div className="v2-online-btn-grey">
              <ButtonLink
                leftIcon={<MouseIcon />}
                href={data.ctaOnlineLink}
                variant="primary"
                id="online-link-cta"
                onClick={() => onCtaClick('online', data.ctaOnlineLink)}
              >
                {copy.ctaOnlineText}
              </ButtonLink>
            </div>
          </div>
        </div>
      }
    />
  );
};
